import { render, staticRenderFns } from "./Addedit.vue?vue&type=template&id=3963a1fb"
import script from "./Addedit.vue?vue&type=script&lang=js"
export * from "./Addedit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports